const prefix = 'event/'

const type = {
    GET_LIST_EVENT: prefix + 'get_list_event',
    GET_LIST_EVENT_DONE: prefix + 'get_list_event_done',
    CREATE_NEW_EVENT: prefix + 'create_new_event',
    GET_EVENT_BY_ID: prefix + 'get_event_by_id',
    GET_EVENT_BY_ID_DONE: prefix + 'get_event_by_id_done',
    UPDATE_EVENT_BY_ID: prefix + 'update_event_by_id',
    DELETE_EVENT_BY_ID: prefix + 'delete_event_by_id',
    VISIBLE_MODAL_EDIT: prefix + 'visible_modal_edit',
    VISIBLE_MODAL_REMOVE: prefix + 'visible_modal_remove',
    VISIBLE_MODAL_CREATE: prefix + 'visible_modal_create',
    GET_LIST_EVENT_QUERY_BY_ID: prefix + 'get_list_event_query_id',
    GET_LIST_EVENT_QUERY_BY_ID_DONE: prefix + 'get_List_event_query_id_done',
    GET_OWNER_EVENT_INFO: prefix + 'GET_OWNER_EVENT_INFO',
    GET_OWNER_EVENT_INFO_DONE: prefix + 'GET_OWNER_EVENT_INFO_DONE',
    SEARCH_EVENT_BY_TEXT: prefix + 'SEARCH_EVENT_BY_TEXT',
    SEARCH_EVENT_BY_TEXT_DONE: prefix + 'SEARCH_EVENT_BY_TEXT_DONE',
}
const loadType = {
    GET_ALL: -1,
    GET_NOT_DELETED: 0,
    GET_DELETED: 1,
}
const action = {
    searchEventByText: (page_number, page_size, text, status, begin_time, end_time, type_search) => {
        return {
            type: type.SEARCH_EVENT_BY_TEXT,
            payload: { page_number, page_size, text, status, begin_time, end_time, type_search },
        }
    },
    searchEventByTextDone: (data, total) => {
        return {
            type: type.SEARCH_EVENT_BY_TEXT_DONE,
            payload: { data, total },
        }
    },

    getOwnerInfoEvent: id => {
        return {
            type: type.GET_OWNER_EVENT_INFO,
            payload: {
                id,
            },
        }
    },
    getOwnerInfoEventDone: data => {
        return {
            type: type.GET_OWNER_EVENT_INFO_DONE,
            payload: {
                data,
            },
        }
    },
    getListEvent: (page_number, page_size, deleted) => {
        return {
            type: type.GET_LIST_EVENT,
            payload: {
                page_number,
                page_size,
                deleted,
            },
        }
    },
    getListEventDone: (data, total) => {
        return {
            type: type.GET_LIST_EVENT_DONE,
            payload: {
                data,
                total,
            },
        }
    },
    createNewEvent: body => {
        return {
            type: type.CREATE_NEW_EVENT,
            payload: { body },
        }
    },
    getEventById: eid => {
        return {
            type: type.GET_EVENT_BY_ID,
            payload: { eid },
        }
    },
    getEventByIdDone: data => {
        return {
            type: type.GET_EVENT_BY_ID_DONE,
            payload: { data },
        }
    },

    updateEventById: (eid, body) => {
        return {
            type: type.UPDATE_EVENT_BY_ID,
            payload: {
                eid,
                body,
            },
        }
    },
    deleteEventById: eid => {
        return {
            type: type.DELETE_EVENT_BY_ID,
            payload: { eid },
        }
    },
    visibleEditModal: isVisible => {
        return {
            type: type.VISIBLE_MODAL_EDIT,
            payload: { isVisible },
        }
    },
    visibleRemoveModal: (isVisible, eid) => {
        return {
            type: type.VISIBLE_MODAL_REMOVE,
            payload: { isVisible, eid },
        }
    },
    visibleCreateModal: isVisible => {
        return {
            type: type.VISIBLE_MODAL_CREATE,
            payload: { isVisible },
        }
    },
    getListEventQueryId: lst => {
        return {
            type: type.GET_LIST_EVENT_QUERY_BY_ID,
            payload: { lst },
        }
    },
    getListEventQueryIdDone: data => {
        return {
            type: type.GET_LIST_EVENT_QUERY_BY_ID_DONE,
            payload: { data },
        }
    },
}

export default {
    type,
    action,
    loadType,
}
